@if (this.fusionService.selectedFusionContent) {
  <div>
    @if (!hideHeader()) {
      <div
        class="row mb-3"
        >
        <div class="col">
          <app-admin-back-button i18n="@@fusionview-overview">Fusion-Views im Überblick</app-admin-back-button>
        </div>
        <div class="col text-end">
          <span class="h5">
            {{this.fusionService.selectedFusionContent.metadata.name}}
          </span>
          <a
            pButton
            href="/{{this.langService.getLanguage()}}/fusion/{{this.fusionService.selectedFusionContent.metadata.botId}}/{{this.fusionService.selectedFusionContent._id}}"
            size="small"
            severity="primary"
            target="_fusion{{this.fusionService.selectedFusionContent.metadata.type}}"
            >
            <i class="ri-external-link-line"></i>
            <span i18n="@@preview">Vorschau</span>
          </a>
        </div>
      </div>
    }
    @if (this.fusionService.selectedFusionContent.metadata.type === 'rise') {
      <app-fusion-rise-config>
      </app-fusion-rise-config>
    }
    @if (this.fusionService.selectedFusionContent.metadata.type === 'lxt') {
      <app-fusion-lxt-config>
      </app-fusion-lxt-config>
    }
    @if (this.fusionService.selectedFusionContent.metadata.type === 'knowledgeworker') {
      <app-fusion-knowledgeworker-config
      ></app-fusion-knowledgeworker-config>
    }
    @if (this.fusionService.selectedFusionContent.metadata.type === 'storyline') {
      <app-fusion-storyline-config>
      </app-fusion-storyline-config>
    }
    @if (this.fusionService.selectedFusionContent.metadata.type === 'youtube') {
      <app-fusion-youtube-config>
      </app-fusion-youtube-config>
    }
    @if (this.fusionService.selectedFusionContent.metadata.type === 'htmlpage') {
      <app-fusion-htmlpage-config>
      </app-fusion-htmlpage-config>
    }
    @if ($any(this.fusionService.selectedFusionContent.metadata.type) === 'html-as-media') {
      <app-fusion-html-as-media-config
      ></app-fusion-html-as-media-config>
    }
    @if (this.fusionService.selectedFusionContent.metadata.type === 'captivate') {
      <app-fusion-captivate-config>
      </app-fusion-captivate-config>
    }
    @if (this.fusionService.selectedFusionContent.metadata.type === 'miro-by-template') {
      <app-fusion-miro-by-template>
      </app-fusion-miro-by-template>
    }
    @if (this.fusionService.selectedFusionContent.metadata.type === 'miro-by-url') {
      <app-fusion-miro-by-url>
      </app-fusion-miro-by-url>
    }
    @if (this.fusionService.selectedFusionContent.metadata.type.startsWith('iframely_')) {
      <app-fusion-iframely-config
        [iframelyType]="this.fusionService.selectedFusionContent.metadata.type.replace('iframely_', '')"
      ></app-fusion-iframely-config>
    }
  </div>
}
